import type { FC } from "react";
import styled from "styled-components";

export type SquareProps = {
    color?: string;
    text?: string;
};

export const Square: FC<SquareProps> = ({ color, text }) => {
    const squareStyle = {
        backgroundColor: color, // Set the background color based on the prop
    };

    return <StyledDiv style={squareStyle}>{text}</StyledDiv>;
};

const StyledDiv = styled.div`
    width: 100px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 10px;
    color: white;
`;
